import { Box, CircularProgress } from "@mui/material";
import { useSelector } from "react-redux";

import CustomButton, {
  CustomButtonProps,
} from "components/common/CustomButton/CustomButton";
import { customStylesSelector } from "store/selectors/selectors";

interface PaymentFooterProps {
  backButtonProps?: CustomButtonProps;
  submitButtonProps: CustomButtonProps & { onClickCB?: (e?: any) => void };
  isLoading: boolean;
}

const PaymentFooter: React.FunctionComponent<PaymentFooterProps> = ({
  backButtonProps,
  submitButtonProps,
  isLoading,
}) => {
  const customStyles = useSelector(customStylesSelector);

  // Get contrasting color for spinner - use button background as spinner color
  // (since text is usually the background color in this design)
  const spinnerColor = customStyles?.button?.backgroundColor || "inherit";

  return (
    <Box sx={{ display: "flex", justifyContent: "end" }}>
      {backButtonProps && <CustomButton {...backButtonProps} />}
      <CustomButton
        data_cy="payment-footer-make-payment-btn"
        type={submitButtonProps.type ?? "button"}
        {...submitButtonProps}
        btnText={
          isLoading ? (
            <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
              <CircularProgress size={20} sx={{ color: spinnerColor }} />
            </Box>
          ) : (
            submitButtonProps.btnText
          )
        }
      />
    </Box>
  );
};

export default PaymentFooter;
